export enum ProductExclusionType {
  EntireProgram = 'entire-program',
  ProgramPoints = 'program-points',
}
